<template>
  <div>
    <a-button type="primary" @click="showModal" > Start Me up </a-button>
    <a-modal v-model="visible" @ok="handleOk" :footer="null" class="modal" bodyStyle="padding: 1.5rem 0">
      <div class="title" >興味のあるカテゴリ</div>
      <div class="item-collapse">
        <a-collapse expandIconPosition="right" >
          <a-collapse-panel v-for="interest_item in intereset_list" :key="interest_item.name" :header="interest_item.name" :style="customStyle_panel">
            <div class="option-list">
              <a-button class="option-btn" v-for="option_item in interest_item.option" :key="option_item.id" @click="changeColor(option_item)" :class="{option_btn_active: option_item.choice  }"><span>{{option_item.value}}</span></a-button>
            </div>
          </a-collapse-panel>
        </a-collapse> 
      </div>
      <a-button class="submit-btn "><span class="title-btn">変更する</span></a-button>
    </a-modal>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false,
      intereset_list: [
        {
          name: '旅',
          option: [
            {
              id: 1,
              value: 'レジャー',
              choice: false
            }, 
            {
              id: 2,
              value: 'エンタメ',
              choice: false
            },
            {
              id: 3,
              value: 'スポーツ',
              choice: false
            }
          ]
        },
        {
          name: '遊ぶ',
          option: [
            {
              id: 1,
              value: 'レジャー',
              choice: false
            }, 
            {
              id: 2,
              value: 'エンタメ',
              choice: false
            },
            {
              id: 3,
              value: 'スポーツ',
              choice: false
            }
          ]
        },
        {
          name: '食べる',
          option: [
            {
              id: 1,
              value: 'レジャー',
              choice: false
            }, 
            {
              id: 2,
              value: 'エンタメ',
              choice: false
            },
            {
              id: 3,
              value: 'スポーツ',
              choice: false
            }
          ]
        }, {
          name: '買い物',
          option: [
            {
              id: 1,
              value: 'レジャー',
              choice: false
            }, 
            {
              id: 2,
              value: 'エンタメ',
              choice: false
            },
            {
              id: 3,
              value: 'スポーツ',
              choice: false
            }
          ]
        },
        {
          name: '育児・介護・健康',
          option: [
            {
              id: 1,
              value: 'レジャー',
              choice: false
            }, 
            {
              id: 2,
              value: 'エンタメ',
              choice: false
            },
            {
              id: 3,
              value: 'スポーツ',
              choice: false
            }
          ]
        },
        {
          name: 'その他',
          option: [
            {
              id: 1,
              value: 'レジャー',
              choice: false
            }, 
            {
              id: 2,
              value: 'エンタメ',
              choice: false
            },
            {
              id: 3,
              value: 'スポーツ',
              choice: false
            }
          ]
        }
      ],
      customStyle_panel: 'background-color: #ffffff'
    }
  },
  methods: {
    changeColor(option_item) {
      if(option_item.choice === true) {
        option_item.choice = false
        return
      }
      option_item.choice = true
    },
    showModal() {
      this.visible = true
    },
    handleOk() {
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>  